/* Load animated demonstrations close to the viewport, preserving autoplay / loop. */
(function () {
  'use strict';
  function start(video) {
    var gallerySlide = video.closest('.mySwiper2 .swiper-slide');
    if (gallerySlide && (!gallerySlide.classList.contains('swiper-slide-active') || video.style.visibility === 'hidden')) {
      video.pause();
      return;
    }
    if (!video.dataset.vivarroLoaded) {
      video.dataset.vivarroLoaded = 'true';
      video.src = video.dataset.vivarroSrc;
      video.load();
    }
    var play = video.play();
    if (play && play.catch) play.catch(function () {});
  }
  function init(scope) {
    var videos = scope.querySelectorAll('[data-vivarro-video]:not([data-vivarro-observed])');
    videos.forEach(function (video) {
      video.dataset.vivarroObserved = 'true';
      video.addEventListener('vivarro:gallery-active', function () {
        var rect = video.getBoundingClientRect();
        if (rect.bottom > -200 && rect.top < window.innerHeight + 200) start(video);
      });
      if (observer) observer.observe(video);
      else start(video);
    });
  }
  var observer = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) start(entry.target);
      else entry.target.pause();
    });
  }, { rootMargin: '200px 0px' }) : null;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
